<app-loading *ngIf="contentReady"></app-loading>
<div class="container-fluid p-0">
  <div class="d-sm-flex">


    <div class="col-12 col-sm-12 main-content">
      <div class="container-fluid mb-4">
        <div class="categoryContainer">
          <div>
            <mat-form-field>
              <mat-label>{{ "Search" | translate }}</mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="{{ 'Search' | translate }}">
            </mat-form-field>
            <button routerLink="/Profile" class="first-btn btn btn-primary">
              {{ "my profile" | translate }}
            </button>
            @if (isAdmin) {
            <button routerLink="/Resigter" class="btn btn-primary">
              {{ "add User" | translate }}
            </button>



            <!-- <button (click)="exportToExcel()" class="first-btn btn btn-primary">
              {{ "export to excel" | translate }}
            </button> -->
}
          </div>
        </div>
        <div>
          <table mat-table id="userstable" [dataSource]="dataSource" class="mat-elevation-z8">

            <!-- Position Column -->

            <ng-container matColumnDef="username">
              <th mat-header-cell *matHeaderCellDef> {{ "username" | translate }} </th>
              <td mat-cell *matCellDef="let element"> {{element.username}} </td>
            </ng-container>

            <ng-container matColumnDef="first_name">
              <th mat-header-cell *matHeaderCellDef> {{ "first_name" | translate }} </th>
              <td mat-cell *matCellDef="let element"> {{element.first_name}} </td>
            </ng-container>
            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef>{{ "phone" | translate }} </th>
              <td mat-cell *matCellDef="let element"> {{element.phone}} </td>
            </ng-container>
            <!-- Weight Column -->
            <ng-container matColumnDef="last_name">
              <th mat-header-cell *matHeaderCellDef>{{ "last_name" | translate }} </th>
              <td mat-cell *matCellDef="let element"> {{element.last_name}} </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>{{ "account type" | translate }} </th>
              <td mat-cell *matCellDef="let element">

                <div [ngSwitch]="element.type">
                  <div *ngSwitchDefault>{{ "admin" | translate }}</div>
                  <div *ngSwitchCase="'6'">{{ "subadmin" | translate }} </div>
                  <div *ngSwitchCase="'7'">{{ "employee" | translate }} </div>
                  <div *ngSwitchCase="'2'">{{ "financial" | translate }} </div>
                </div>




              </td>
            </ng-container>
                  <ng-container matColumnDef="has_access_to_phone_numbers">
              <th mat-header-cell *matHeaderCellDef>بيشوف الارقام </th>
              <td mat-cell *matCellDef="let element">

                <div [ngSwitch]="element.has_access_to_phone_numbers">
                  
                  <div *ngSwitchCase="1">اه </div>
                  <div *ngSwitchCase="0">لا </div>
            
                </div>




              </td>
            </ng-container>
            <!-- Symbol Column -->
            <ng-container matColumnDef="instagram_link">
              <th mat-header-cell *matHeaderCellDef> {{ "instagram" | translate }}</th>
              <td mat-cell *matCellDef="let element">
                @if(element.instagram_link == null){
                <span>{{ "not specific" | translate }}</span>
                }
                @else{
                <a (click)="go(element.instagram_link)">{{ "instagram" | translate }}

                </a>
                }
              </td>
            </ng-container>


            <ng-container matColumnDef="facebook_link">
              <th mat-header-cell *matHeaderCellDef>{{ "facebook" | translate }} </th>
              <td mat-cell *matCellDef="let element">
                @if(element.facebook_link == null){
                <span>{{ "not specific" | translate }}</span>
                }
                @else{
                <a (click)="go(element.facebook_link)">{{ "facebook" | translate }}

                </a>
                }

              </td>
            </ng-container>
            <ng-container matColumnDef="tiktok_link">
              <th mat-header-cell *matHeaderCellDef>{{ "tiktok" | translate }} </th>
              <td mat-cell *matCellDef="let element">
                @if(element.tiktok_link == null){
                <span>{{ "not specific" | translate }} </span>
                }
                @else{
                <a (click)="go(element.tiktok_link)">
                  {{ "tiktok" | translate }}
                </a>
                }

              </td>
            </ng-container>




            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element">

                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">

                    <li><a class="dropdown-item" (click)='edituser(element)'> 
                      {{ "Edit" | translate }} </a></li>
                    <li><a class="dropdown-item" (click)='showpassword(element.read_password)'> 
                      {{ "Show Password" | translate }} </a></li>
                    @if (isAdmin) {
                      <li><a class="dropdown-item" (click)='deleteuser(element.id)'>{{ "Delete" | translate }}</a></li>
                    }


                  </ul>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>


        </div>

        <div class="row">
          @if (noData) {
          <app-nodata></app-nodata>
          } @else {


          }
        </div>
      </div>
    </div>
  </div>
</div>
